import { createSelector } from 'reselect';

const formsSelector = (state) => state.forms;

export const selectForms = createSelector(
  [formsSelector],
  (forms) => forms.forms
);

export const selecActiveForms = createSelector(
  [formsSelector],
  (forms) => forms.forms.content
);

export const selectFormsLoading = createSelector(
  [formsSelector],
  (forms) => forms.loading
);

export const selectFormsError = createSelector(
  [formsSelector],
  (forms) => forms.error
);

export const selectFormSaving = createSelector(
  [formsSelector],
  (forms) => forms.saving
);

export const selectFormErrorSaving = createSelector(
  [formsSelector],
  (forms) => forms.errorSaving
);

export const selectFilterActive = createSelector(
  [formsSelector],
  (forms) => forms.filterOn
);

export const selectTiedApplications = createSelector(
  [formsSelector],
  (forms) => forms.applicationForms
);

export const selectSingleForm = createSelector(
  [formsSelector],
  (forms) => forms.singleForm
);
